import React, { useState, useEffect, useCallback } from 'react';
import {
	NavLink,
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { Result, SpinLoading, Popup, Avatar, List } from 'antd-mobile';

import 'moment/locale/ru';
import { useParams } from 'react-router-dom';
import { pushStateHistoryModal, POST, TranslateContext, useAuth, useNavigation, UserConfigContext, UserContext, useTranslateContext, useUserContext, ycStorage, LanguageContext, Action } from 'fennec-ui';
// --- mobile --- 
// ---  ---  --- 

// 
import './index.less';

import CRUDE_VseTipiPolzovatelei from '../../../objects/VseTipiPolzovatelei/crude'
import { errorCatch, GET, QueryDetail, READWITH } from 'fennec-ui';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { Button } from 'antd';
import { MetaContext } from 'fennec-ui';
import Icofont from 'react-icofont';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { LogoutOutlined } from '@ant-design/icons';
import { MaxIcon, translate, ycBucket } from '../../../common/Tool';
import { LangSwitchContext, useLangSwitchContext } from '../../../common/Context';
import { Dialog } from '../../../common/Dialog';
import LangSwitchMobile from '../../components/LangSwitchMobile';
import QRCode from 'react-qr-code';

var _ = require('lodash');

const mainDark = "#001529";

function Sidebar(props) {
	// const { open, setOpen } = props;
	const { open, menuClose } = props;
	let navigate = useNavigation();
	// const history = useHistory();
	// history.push("/home");
	const auth = useAuth();
	const t = useTranslateContext();
	const user = useUserContext();
	const langSwitch = useLangSwitchContext();
	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);

	const vkbot = process.env.REACT_APP_VKBOT
	const tgbot = process.env.REACT_APP_TGBOT
	const maxbot = process.env.REACT_APP_MAXBOT

	// useEffect(() => {
	// 	setOpen(false)
	// }, [location.pathname]);

	const logout = () => {
		auth.logout(() => {
			navigate('/');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();

		Dialog.confirm({
			content: t('Вы действительно хотите выйти на всех устройствах?'),
			confirmText: t("Выйти"),
			cancelText: t("Отмена"),
			onConfirm: async () => {
				await auth.logoutall(() => {
					navigate('/');
				});
			},
		})
	}

	const [idCard, setIdCard] = useState()
	const loadIdCard = useCallback(() => {
		GET(auth, '/api/idcard', ({ data }) => {
			if (data) {
				setIdCard(data)
			}
		}, (err) => errorCatch(err))
	}, [auth])

	return (
		<Popup
			visible={open}
			// onMaskClick={() => setOpen(false)}
			onMaskClick={menuClose}
			position='right'
			bodyStyle={{ width: '80vw' }}
		>
			<div className='sidebar'>
				<div>
					{user && <div className='user bg bg-grey dark-5' style={{ padding: "4px" }}>
						<Avatar src={(user.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatarMin : ""} />
						<div className='user-name'>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
						</div>
						<div>
							<Action
								auth={auth}
								action={() => {
								}}
								object={idCard}
								modal={{
									title: "QR-id"
								}}

								readonly={true}
								mode={"func"}
								noAntForm={true}
								form={(props) => {
									const { object } = props;
									return <div style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
										{object &&
											<div>
												<div className='bg bg-transparent' style={{ display: "flex", justifyContent: "space-evenly" }}>
													<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} />

													<div className='user-name'>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
													</div>
												</div>

												<div style={{ padding: "15px 5px 20px 5px", backgroundColor: "white", borderRadius: "6px", textAlign: "center" }}>
													<QRCode level="M" value={object} />
												</div>

												<div style={{ display: "flex", justifyContent: "center" }}>
													<Button onClick={loadIdCard}>Обновить</Button>
												</div>
											</div>}
									</div>
								}}
								trigger={(click) => (
									<div onClick={event => {
										event.stopPropagation();
										loadIdCard()
										click()
									}}>
										<i className="fa fa-qrcode" style={{ color: "black", fontSize: "42px", margin: "3px 5px 0 0" }}></i>
									</div>
								)}
							/>
						</div>
					</div>}
					<div className='logout bg bg-grey' style={{ padding: "4px", marginTop: "5px" }} onClick={logout}>
						<div>
							<LogoutOutlined />
							<span style={{ paddingLeft: "5px" }}> {t("Выход")}</span>
						</div>
						<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
							<Icofont icon="logout" />
						</div>
					</div>
				</div>
				<div>
					{langSwitch}
				</div>
				<div>
					<div style={{ padding: "5px 0px", display: "flex", alignItems: "center", gap: "5px" }}>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(tgbot) ? 'https://t.me/' + tgbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.tgchatid) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><i className="fa fa-telegram" style={{ fontSize: "14px" }}></i></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.tgchatid) && <div>Telegram</div>}
										{(user && user.tgchatid) && <div>Telegram</div>}
									</div>
								</div>
							</a>
						</div>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(vkbot) ? 'https://vk.com/im?sel=-' + vkbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.vk) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><i className="fa fa-vk" style={{ fontSize: "14px" }}></i></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.vk) && <div>VK</div>}
										{(user && user.vk) && <div>VK</div>}
									</div>
								</div>
							</a>
						</div>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(maxbot) ? 'https://max.ru/' + maxbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.maxchatid) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><MaxIcon width={14} height={14} color="#4096ff" /></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.maxchatid) && <div>Max</div>}
										{(user && user.maxchatid) && <div>Max</div>}
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
				<div>
					{!!akkauntiPolzovatelei && <div className="bg bg-grey" style={{ padding: "5px 10px", textAlign: "left", marginBottom: "5px" }}>
						<div>Баланс:</div>
						{akkauntiPolzovatelei.map((e, idx) => <div key={idx} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", fontSize: "13px" }}>
							<div>
								№{e.akkaunt.nomerAkkaunta}
							</div>
							<div style={{ flex: "auto", textAlign: "end", paddingLeft: "15px", color: (e.akkaunt.ostatok > 0) ? "green" : "red" }}>
								{Number(e.akkaunt.ostatok.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
							</div>
						</div>)}
					</div>}
					<div style={{ padding: "0px 0px" }}>
						<List>
							<List.Item
								prefix={<i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i>}
								className={"bg-blue"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`}>
									{t("Главный сайт")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="home" style={{ fontSize: "13px", color: "orange" }} />}
								className={"bg-orange"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`}>
									{t("Личный кабинет")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="ui-calendar" style={{ fontSize: "13px", color: "green" }} />}
								className={"bg-green"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`}>
									{t("Войти в мероприятие")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="user" style={{ fontSize: "13px" }} />}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`}>
									{t("Профиль")}
								</a>
							</List.Item>
						</List>
					</div>
				</div>
			</div>
		</Popup>
	);
}


function PaymentResult(props) {
	let navigate = useNavigation();
	let { number } = useParams();
	const auth = useAuth();
	const dispatch = useDispatch();

	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));
	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	const meta = useSelector(state => state.meta);
	const user = useSelector(state => state.home.user);

	const [online, setOnline] = useState(false);
	const [loading, setLoading] = useState(false);

	const [zakaz, setZakaz] = useState(undefined);


	useEffect(
		() => {
			auth.fetch('/api/meta').then(res => {
				if (res && res.data && dispatch) {
					dispatch({ type: 'META', payload: res.data })
				}
			});
			auth.fetch('/api/iam').then(res => {
				if (res && res.data) {
					dispatch({ type: 'USER', payload: res.data })
				}
			});
			READWITH(auth, 'Translate', [
				QueryDetail("model")
			], ({ data }) => {
				if (data.length > 0) {
					let o = Object.fromEntries(data.map(i => {
						return [
							i.key,
							{
								ru: i.ru,
								en: i.en,
								es: i.es,
								tr: i.tr,
							},
						]
					}));
					dispatch(REDUX_Translate.actions.setObject(o));
				}
			}, errorCatch)
			READWITH(auth, 'UserConfig', [
				QueryDetail("model")
			], ({ data }) => {
				if (data.length > 0) {
					var obj = Object.fromEntries(data.map(i => {
						return [
							i.key,
							i.value
						]
					}));
					dispatch(REDUX_UserConfig.actions.setObject(obj));
				}
			}, errorCatch)
			CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
				if (data.length > 0) {
					dispatch({ type: 'ROLE', payload: data });
				}
			}, 'model', 's-id=ASC');
			GET(auth, `/api/zakaz/by-nomer-for-payment-result-page/${number}`,
				({ data }) => {
					if (data) {
						if (data?.status?.ID == 1) {
							let count = 10;
							let intervalId = setInterval(() => {
								count--;
								if (count == 0) {
									clearInterval(intervalId);
								}
								GET(auth, `/api/zakaz/by-nomer-for-payment-result-page/${number}`,
									({ data }) => {
										if (data) {
											if (data?.status?.ID != 1) {
												clearInterval(intervalId);
											}
											setZakaz(data);
										}
										setLoading(false);
									}, (err) => errorCatch(err, () => setLoading(false)));
							}, 5000)
						}
						setZakaz(data);
					}
					setLoading(false);
				}, (err) => errorCatch(err, () => setLoading(false)));
			RefreshAkkaunti();
			auth.openSocket("/ws/service", "service",
				function (type, payload) {
					if (type === "reload") {
						window.location.href = window.location.href;
					}
					switch (type) {
						case "siteaccess":
							dispatch({ type: "SITE_ACCESS", payload: payload });
							break;
						case "AkkauntiPolzovatelei":
							dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
							break;
						case "NeedUpdateAkkauntPolzovatelya":
							RefreshAkkaunti();
							break;
						default:
							break;
					}
				},
				//onopen
				function () {
					setOnline(true);
				},
				//onclose
				function () {
					setOnline(false);
				}
			);
			return () => {
				auth.closeSocket("service");
			};
		}, []);

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });

	const goToHome = () => {
		navigate("/app");
	}

	// const [open, setOpen] = useState(false);
	// const onOpenChange = () => {
	// 	setOpen(!open);
	// }

	const stack = [];
	const getStack = React.useCallback(() => {
		return stack;
	}, []);

	const [open, setOpen] = useState(false);
	const menuClose = () => {
		if (open) {
			window.history.back();
		}
	}
	const onOpenChange = () => {
		if (!open) {
			pushStateHistoryModal(setOpen, getStack);
			setOpen(true);
			return
		}
		menuClose();
	}
	const goToOneMoreOrder = () => {
		if (zakaz) {
			navigate(`/app/pay/${zakaz.meropriyatieID}`);
		}
	}

	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitchMobile userConfig={userConfig} />}>
								<div className='app'>
									<div className='header' style={{ display: "flex", justifyContent: "space-between", backgroundColor: mainDark }}>
										<NavLink to="/fed/events">
											<div style={{ flex: 0 }}>
												<div className="logo-mobile" />
											</div>
										</NavLink>
										<div style={{ flex: 0 }}>
											<div className='sider-button'>
												<Icofont key="1" icon="navigation-menu" onClick={onOpenChange} />
											</div>
										</div>
									</div>
									<div className='content'>
										{/* <Sidebar open={open} setOpen={setOpen} /> */}
										<Sidebar open={open} menuClose={menuClose} getStack={getStack} />
										<div className='page'>
											<div>
												<div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
													{!!loading && <div style={{
														width: "100%",
														minHeight: "150px",
														display: "flex",
														justifyContent: "center",
														alignItems: "center"
													}}>
														<SpinLoading style={{ '--size': '32px' }} />
													</div>}
													{(zakaz?.status?.ID === 1) && <>
														<div style={{ fontSize: "20px", textAlign: "center" }}>
															<Result
																status={"info"}
																title={"Ожидаем поступления денежных средств"}
																// icon={<Icofont icon="check-circled" style={{ fill: 'rgb(109 175 23)' }} />}
																description={
																	<div>
																		<div>Номер заказа: {number}</div>
																		<div>Сумма заказа: <span style={{ color: "black" }}>{zakaz.obshchayaSumma.toLocaleString()} руб.</span></div>
																	</div>
																}
															/>
															<div style={{ paddingTop: "25px", display: "flex", justifyContent: "center", gap: "10px" }}>
																<Button type="primary" key="console" onClick={goToHome}>
																	Личный кабинет
																</Button>
																<Button key="buy" onClick={goToOneMoreOrder}>Ещё один заказ</Button>
															</div>
														</div>
													</>}
													{(zakaz?.status?.ID === 2) && <>
														<div style={{ fontSize: "20px", textAlign: "center" }}>
															<Result
																status={"warning"}
																title={"Оплата возвращена!"}
																description={
																	<div>
																		<div>Номер заказа: {number}</div>
																		<div>Сумма заказа: <span style={{ color: "black" }}>{zakaz.obshchayaSumma.toLocaleString()} руб.</span></div>
																	</div>
																}
															/>
															<div style={{ paddingTop: "25px", display: "flex", justifyContent: "center", gap: "10px" }}>
																<Button type="primary" key="console" onClick={goToHome}>
																	Личный кабинет
																</Button>
																<Button key="buy" onClick={goToOneMoreOrder}>Ещё один заказ</Button>
															</div>
														</div>
													</>}
													{(zakaz?.status?.ID === 3 || zakaz?.status?.ID === 4) && <>
														<div style={{ fontSize: "20px", textAlign: "center" }}>
															<Result
																status={"success"}
																title={"Заказ успешно оплачен!"}
																description={
																	<div>
																		<div>Номер заказа: {number}</div>
																		<div>Сумма заказа: <span style={{ color: "black" }}>{zakaz.obshchayaSumma.toLocaleString()} руб.</span></div>
																	</div>
																}
															/>
															<div style={{ paddingTop: "25px", display: "flex", justifyContent: "center", gap: "10px" }}>
																<Button type="primary" key="console" onClick={goToHome}>
																	Личный кабинет
																</Button>
																<Button key="buy" onClick={goToOneMoreOrder}>Ещё один заказ</Button>
															</div>
														</div>
													</>}
													{(zakaz?.status?.ID === 5) && <>
														<div style={{ fontSize: "20px", textAlign: "center" }}>
															<Result
																// img={<Icofont icon="close-circled" style={{ fill: '#F13642' }} />}
																status='error'
																title="Ошибка оплаты заказа!"
																description={
																	<div>
																		<div>Номер заказа: {number}</div>
																		<div>Сумма заказа: <span style={{ color: "black" }}>{zakaz.obshchayaSumma.toLocaleString()} руб.</span></div>
																	</div>
																}
															/>
															<div style={{ paddingTop: "25px", display: "flex", justifyContent: "center", gap: "10px" }}>
																<Button type="primary" key="console" onClick={goToHome}>
																	Личный кабинет
																</Button>
																<Button key="buy" onClick={goToOneMoreOrder}>Ещё один заказ</Button>
															</div>
														</div>
													</>}
												</div>
											</div>
										</div>
									</div>
									<div className={"footer"}>
										{/* {footer} */}
										{/* <TabBar
										safeArea={true}
										activeKey={location.pathname}
										onChange={value => navigate(value)}>
										<TabBar.Item
											key={"/protocol"}
											icon={<Icofont icon="list" style={{ fontSize: '24px' }} />}
											title={t("Протокол")}
										/>
										<TabBar.Item
											key={"/judge"}
											icon={<Icofont icon="user-alt-7" style={{ fontSize: '24px' }} />}
											title={t("Судья")}
										/>
									</TabBar> */}
									</div>
								</div>
							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider >
	);
};

export default PaymentResult;